import { getDefaultStore } from 'jotai';
import { authUserMetaAtom } from '@/store/authAtoms';
import { selectedFacilityAtom } from '@/store/facilityAtom';

// Honors ?sitegroup=XYZ on email deep links (e.g. exam share summaries).
// Only applies pre-login so a stale link can't silently switch an
// authenticated user's facility out from under them. The param is stripped
// from the URL after it's consumed so it's not re-shared or re-applied on
// reload.
const PARAM_NAMES = ['sitegroup', 'siteGroup', 'SiteGroup'];

export function bootstrapSiteGroupFromUrl(): void {
  const search = new URLSearchParams(window.location.search);
  const paramKey = PARAM_NAMES.find((k) => search.has(k));
  if (!paramKey) return;

  const code = search.get(paramKey)?.trim();
  if (!code) return;

  const store = getDefaultStore();
  if (store.get(authUserMetaAtom)) return;

  const current = store.get(selectedFacilityAtom);
  if (!current || current.id !== code) {
    store.set(selectedFacilityAtom, { id: code, name: code });
  }

  // Prevent the marketing domain bootstrap from overriding a facility that
  // was explicitly supplied via URL param (e.g. exam-share email deep links).
  sessionStorage.setItem('pp_facility_from_url_param', '1');

  search.delete(paramKey);
  const newQuery = search.toString();
  const cleanUrl =
    window.location.pathname +
    (newQuery ? `?${newQuery}` : '') +
    window.location.hash;
  window.history.replaceState(null, '', cleanUrl);
}
